import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import moment from "moment";
import {
  setMenuTopIndex,
  setMenuLeftContent,
  setMenuLeftIndex,
  setMenuLeftItemIndex
} from "../../../redux/actions/menuActions";
import MerchList from "../../../containers/admin/merch/List";
import MenuAdmin from "../Menu";
import Status from "components/status/Status.js";
import { Dropdown, Menu, Modal } from "antd";
import { getReferentielsList, init } from "../../../redux/actions/referentielsActions";
import { setSort } from "../../../redux/actions/referentielsActions";

import { currentClientSelector } from "../../../redux/selectors/auth";

class Metier extends Component {
  state = { selectedItem: {}, isModalVisible: false };
  componentDidMount() {
    this.props.setMenuTopIndex("imports");
    this.props.setMenuLeftContent(MenuAdmin);
    this.props.setMenuLeftIndex("merch");
  }
  getColumns = () => {
    //TODO refactor
    const merchs = ["mea", "plv", "ilv", "oc", "bri"];
    // const columnsMerchs = merchs.map(type => ({
    //   title: { type },
    //   dataIndex: "data",
    //   key: { type },
    //   render: (text, record, index) => {
    //     const data = record.data || {};
    //     const types = data[type] || [];

    //     return (
    //       <Fragment>
    //         <Dropdown
    //           overlay={
    //             <Menu
    //              style={{ overflow: "scroll", height: "100vh" }}
    //               onClick={e => {
    //                 this.setState({ selectedItem: types[e.key], isModalVisible: true });
    //               }}
    //             >
    //               {types.map((item, index) => (
    //                 <Menu.Item key={index}>{item.product_label}</Menu.Item>
    //               ))}
    //             </Menu>
    //           }
    //         >
    //           <a
    //             className="ant-dropdown-link"
    //             onClick={e => {
    //               e.preventDefault();
    //             }}
    //           >
    //             {types.length} élément(s)
    //           </a>
    //         </Dropdown>
    //       </Fragment>
    //     );
    //   }
    // }));
    const columnsStatus = [
      {
        title: "Ordre",
        dataIndex: "index",
        key: "index",
        sortable: true,
        render: (text, record, index) => {
          return <div>{index + 1}</div>;
        }
      },
      {
        title: "Statut",
        dataIndex: "active",
        key: "active",
        sortable: true,
        render: (text, record, index) => {
          const isActive = record.active;
          const statusId = isActive ? 2 : 3;

          return <Status statusId={statusId} />;
        }
      },

      {
        title: "Date de création",
        dataIndex: "created_at",
        key: "created_at",
        sortable: true,
        render: (text, record) => {
          return <div>{moment(record.created_at).format("DD/MM/YYYY")}</div>;
        }
      },
      {
        title: "Dernière modification",
        dataIndex: "updated_at",
        key: "updated_at",
        sortable: true,
        render: (text, record) => {
          return <div>{moment(record.updated_at).format("DD/MM/YYYY")}</div>;
        }
      },

      {
        title: "MEA",
        //a modifier
        dataIndex: "data",
        key: "mea",
        render: (text, record, index) => {
          const data = record.data || {};
          const meas = data.mea || [];

          return (
            <Fragment>
              <Dropdown
                overlay={
                  <Menu
                    style={{ overflow: "scroll", maxHeight: "100vh" }}
                    onClick={e => {
                      this.setState({ selectedItem: meas[e.key], isModalVisible: true });
                    }}
                  >
                    {meas.map((item, index) => (
                      <Menu.Item key={index}>{item.product_label}</Menu.Item>
                    ))}
                  </Menu>
                }
              >
                <a
                  className="ant-dropdown-link"
                  onClick={e => {
                    e.preventDefault();
                  }}
                >
                  {meas.length} élément(s)
                </a>
              </Dropdown>
            </Fragment>
          );
        }
      },
      {
        title: "PLV",
        //a modifier
        dataIndex: "data",
        key: "plv",
        render: (text, record, index) => {
          const data = record.data || {};
          const plvs = data.plv || [];

          return (
            <Fragment>
              <Dropdown
                overlay={
                  <Menu
                    style={{ overflow: "scroll", maxHeight: "100vh" }}
                    onClick={e => {
                      this.setState({ selectedItem: plvs[e.key], isModalVisible: true });
                    }}
                  >
                    {plvs.map((item, index) => (
                      <Menu.Item key={index}>{item.product_label}</Menu.Item>
                    ))}
                  </Menu>
                }
              >
                <a
                  className="ant-dropdown-link"
                  onClick={e => {
                    e.preventDefault();
                  }}
                >
                  {plvs.length} élément(s)
                </a>
              </Dropdown>
            </Fragment>
          );
        }
      },
      {
        title: "ILV",
        //a modifier
        dataIndex: "data",
        key: "ilv",
        render: (text, record, index) => {
          const data = record.data || {};
          const ilvs = data.ilv || [];

          return (
            <Fragment>
              <Dropdown
                overlay={
                  <Menu
                    style={{ overflow: "scroll", maxHeight: "100vh" }}
                    onClick={e => {
                      this.setState({ selectedItem: ilvs[e.key], isModalVisible: true });
                    }}
                  >
                    {ilvs.map((item, index) => (
                      <Menu.Item key={index}>{item.product_label}</Menu.Item>
                    ))}
                  </Menu>
                }
              >
                <a
                  className="ant-dropdown-link"
                  onClick={e => {
                    e.preventDefault();
                  }}
                >
                  {ilvs.length} élément(s)
                </a>
              </Dropdown>
            </Fragment>
          );
        }
      },
      {
        title: "OC",
        //a modifier
        dataIndex: "data",
        key: "oc",
        render: (text, record, index) => {
          const data = record.data || {};
          const ocs = data.oc || [];

          return (
            <Fragment>
              <Dropdown
                overlay={
                  <Menu
                    style={{ overflow: "scroll", maxHeight: "100vh" }}
                    onClick={e => {
                      this.setState({ selectedItem: ocs[e.key], isModalVisible: true });
                    }}
                  >
                    {ocs.map((item, index) => (
                      <Menu.Item key={index}>{item.product_label}</Menu.Item>
                    ))}
                  </Menu>
                }
              >
                <a
                  className="ant-dropdown-link"
                  onClick={e => {
                    e.preventDefault();
                  }}
                >
                  {ocs.length} élément(s)
                </a>
              </Dropdown>
            </Fragment>
          );
        }
      },
      {
        title: "BRI",
        //a modifier
        dataIndex: "data",
        key: "bri",
        render: (text, record, index) => {
          const data = record.data || {};
          const bris = data.bri || [];

          return (
            <Fragment>
              <Dropdown
                overlay={
                  <Menu
                    style={{ overflow: "scroll", maxHeight: "100vh" }}
                    onClick={e => {
                      this.setState({ selectedItem: bris[e.key], isModalVisible: true });
                    }}
                  >
                    {bris.map((item, index) => (
                      <Menu.Item key={index}>{item.product_label}</Menu.Item>
                    ))}
                  </Menu>
                }
              >
                <a
                  className="ant-dropdown-link"
                  onClick={e => {
                    e.preventDefault();
                  }}
                >
                  {bris.length} élément(s)
                </a>
              </Dropdown>
            </Fragment>
          );
        }
      },
      {
        title: "SELLOUT",
        //a modifier
        dataIndex: "data",
        key: "sellout",
        render: (text, record, index) => {
          const data = record.data || {};
          const sellouts = data.sellout || [];

          return (
            <Fragment>
              <Dropdown
                overlay={
                  <Menu
                    style={{ overflow: "scroll", maxHeight: "100vh" }}
                    onClick={e => {
                      this.setState({ selectedItem: sellouts[e.key], isModalVisible: true });
                    }}
                  >
                    {sellouts.map((item, index) => (
                      <Menu.Item key={index}>{item.product_label}</Menu.Item>
                    ))}
                  </Menu>
                }
              >
                <a
                  className="ant-dropdown-link"
                  onClick={e => {
                    e.preventDefault();
                  }}
                >
                  {sellouts.length} élément(s)
                </a>
              </Dropdown>
            </Fragment>
          );
        }
      }
    ];
    return columnsStatus;
  };
  render() {
    return (
      <Fragment>
        <Modal
          visible={this.state.isModalVisible}
          onOk={() => this.setState({ isModalVisible: false })}
          onCancel={() => this.setState({ isModalVisible: false })}
          cancelButtonProps={{ style: { display: "none" } }}
        >
          <ul>
            {Object.entries(this.state.selectedItem).map(item => (
              <li style={{ margin: 10, fontSize: 14 }}>
                {item[0]} :{" "}
                <span style={{ color: "#E46901" }}>
                  {Array.isArray(item[1])
                    ? item[1].join(", ")
                    : typeof item[1] !== "boolean"
                    ? item[1]
                    : item[1]
                    ? "oui"
                    : "non"}
                </span>
              </li>
            ))}
          </ul>
        </Modal>

        <MerchList {...this.props} columns={this.getColumns()} />
      </Fragment>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    currentClientLabel: (state.currentClient || {}).label,
    modelsList: state.models.merchList,
    modelsListLoading: state.models.modelsListLoading,
    page: state.models.page,
    pages: state.models.pages,
    pageSize: state.models.pageSize,
    nbItems: state.models.total,
    currentClientLabel: currentClientSelector(state).label,
    currentClientId: currentClientSelector(state).id
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    setMenuTopIndex: index => {
      dispatch(setMenuTopIndex(index));
    },
    setMenuLeftContent: index => {
      dispatch(setMenuLeftContent(index));
    },
    setMenuLeftIndex: index => {
      dispatch(setMenuLeftIndex(index));
    },
    setMenuLeftItemIndex: index => {
      dispatch(setMenuLeftItemIndex(index));
    },
    init: () => dispatch(init("merch")),
    getNext: page => {
      const nextPage = page;
      dispatch(getReferentielsList({ page: nextPage }, "merch"));
    },
    setSort: (column, sortOrder) => dispatch(setSort("merch", column, sortOrder))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Metier);



// WEBPACK FOOTER //
// src/pages/imports/imports/Merch.js